import { render } from "./CustomPopup.vue?vue&type=template&id=213f5b25"
import script from "./CustomPopup.vue?vue&type=script&lang=js"
export * from "./CustomPopup.vue?vue&type=script&lang=js"

import "./CustomPopup.vue?vue&type=style&index=0&id=213f5b25&lang=scss"

import exportComponent from "/home/wf13/Develop/web/vue-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__